import React from 'react';
import { useSchool } from '../context/SchoolContext';
import { Calendar as CalendarIcon, Clock, User, UserCheck, Loader2 } from 'lucide-react';
import './Scheduling.css';

const Scheduling = () => {
    const { lessons, loading } = useSchool();

    const formatTime = (isoString) => {
        if (!isoString) return '--:--';
        try {
            return new Date(isoString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
        } catch (e) {
            return isoString;
        }
    };

    const getDuration = (start, end) => {
        if (!start || !end) return '1h';
        try {
            const diff = new Date(end) - new Date(start);
            const mins = Math.round(diff / 60000);
            if (mins < 60) return `${mins}m`;
            const hours = mins / 60;
            return `${hours % 1 === 0 ? hours : hours.toFixed(1)}h`;
        } catch (e) {
            return '1h';
        }
    };

    if (loading) {
        return (
            <div className="page-container flex flex-col items-center justify-center py-20">
                <Loader2 className="animate-spin text-gold mb-4" size={40} />
                <p className="text-muted">Loading schedule...</p>
            </div>
        );
    }

    return (
        <div className="page-container">
            <div className="page-header">
                <div>
                    <h2 className="page-title">Daily Schedule</h2>
                    <p className="page-subtitle">View lesson bookings and instructor availability</p>
                </div>
                <div className="date-display card flex items-center gap-2 px-3 py-2">
                    <CalendarIcon size={18} className="text-secondary" />
                    <span className="font-medium text-main">{new Date().toLocaleDateString()}</span>
                </div>
            </div>

            <div className="card">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>Time</th>
                            <th>Student</th>
                            <th>Instructor</th>
                            <th>Duration</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lessons.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="text-center py-10 text-muted">No lessons scheduled for today.</td>
                            </tr>
                        ) : (
                            lessons.map(slot => (
                                <tr key={slot.id}>
                                    <td className="font-medium flex items-center gap-2">
                                        <Clock size={16} className="text-muted" />
                                        {formatTime(slot.start_time)}
                                    </td>
                                    <td>
                                        <div className="flex items-center gap-2">
                                            <User size={16} className="text-muted" />
                                            {slot.student_first_name} {slot.student_last_name}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="flex items-center gap-2">
                                            <UserCheck size={16} className="text-muted" />
                                            {slot.instructor_first_name} {slot.instructor_last_name}
                                        </div>
                                    </td>
                                    <td>{getDuration(slot.start_time, slot.end_time)}</td>
                                    <td>
                                        <span className={`status-badge ${(slot.status || 'Scheduled').toLowerCase()}`}>
                                            {slot.status || 'Scheduled'}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Scheduling;
